import { CtBatch } from '@ps-gui/claims-terminal-shared';
import { Observable, of } from 'rxjs';
import { AppView } from '../../models/app-view';

/**
 * ## BaseWorkflowHookService
 * A base service class for defining hooks related to the workflow processing in {@link WorkflowService}.
 * This abstract class is intended to be extended by specific implementations for each {@link BatchDomain}
 * that define custom behavior for workflow hooks.
 *
 * Each hook returns an Observable<boolean>, which determines whether the {@link WorkflowService} <b>could</b> proceed or not.
 */
export abstract class BaseWorkflowHookService {
  /**
   * A method that is invoked before the consolidation process begins.
   * This method can be used to perform any preparatory operations or checks
   * prior to consolidation.
   *
   * @param {CtBatch} ctBatch - The batch context object.
   * @return {Observable<boolean>} An observable that emits a boolean value indicating
   * whether the operation was successful (true) or failed (false).
   */
  beforeConsolidation(ctBatch: CtBatch): Observable<boolean> {
    console.debug('beforeConsolidation', ctBatch);
    return of(true);
  }

  beforeView(view: AppView, ctBatch: CtBatch): Observable<boolean> {
    console.debug('beforeView', view, ctBatch);
    return of(true);
  }

  afterView(view: AppView, nextView: AppView, ctBatch: CtBatch): Observable<boolean> {
    console.debug('afterView', view, ctBatch);
    return of(true);
  }
}
